import { OTCCouponPeriodStatusEnum, assertNever } from '@talos/kyoko';
import type { DealCouponSchedule } from '../../../../types/OTC';

/**
 * Returns the amount of the asset transaction based on the asset transaction status.
 */
export function getDealCouponScheduleAmount(
  schedule: Pick<DealCouponSchedule, 'CashflowStatus' | 'AmountPaid' | 'AmountDue' | 'PV'>
): string | undefined {
  switch (schedule.CashflowStatus) {
    case OTCCouponPeriodStatusEnum.Past:
      return schedule.AmountPaid;
    case OTCCouponPeriodStatusEnum.Due:
      return schedule.AmountDue;
    case OTCCouponPeriodStatusEnum.Current:
    case OTCCouponPeriodStatusEnum.Future:
      return undefined;
    default:
      return assertNever(schedule.CashflowStatus);
  }
}
